import { abortError } from './navAbort.mjs';
// 47102 (A7d R5): at most `cap` GETs in flight per host from this tab; the rest wait in FIFO order. A page that fires 11-15 reads at boot
// no longer floods the API (hosted PostgREST pool ~10) or the browser's 6 HTTP/1.1 connections; cap 5 leaves one connection free for a write.
// Writes (any non-GET) and reads with a body never queue. A queued read whose signal aborts (abort-reads: the user left the page; coalesce: every
// caller left) leaves the queue at once with an AbortError and never reaches the network. Sits UNDER the coalescing fetch (one queue slot per shared read).
export const GET_CAP = 5;
export function makeCappedFetch(doFetch, { cap = GET_CAP } = {}) {
  const hosts = new Map();   // host -> { active, queue: [{ start, cancel }] }
  const hostOf = (url) => { try { return new URL(String(url), typeof window !== 'undefined' ? window.location.href : 'http://localhost/').host; } catch { return ''; } };
  const next = (h) => { while (h.active < cap && h.queue.length) h.queue.shift().start(); };
  return (url, init = {}) => {
    if (String(init.method || 'GET').toUpperCase() !== 'GET' || init.body != null) return doFetch(url, init);
    const key = hostOf(url);
    const h = hosts.get(key) || hosts.set(key, { active: 0, queue: [] }).get(key);
    return new Promise((resolve, reject) => {
      const { signal } = init;
      const onAbort = () => { const i = h.queue.indexOf(item); if (i >= 0) { h.queue.splice(i, 1); reject(abortError()); } };
      const item = {
        start: () => {
          if (signal) signal.removeEventListener('abort', onAbort);
          if (signal && signal.aborted) { reject(abortError()); return; }
          h.active++;
          let p; try { p = Promise.resolve(doFetch(url, init)); } catch (e) { p = Promise.reject(e); }
          p.finally(() => { h.active--; next(h); }).then(resolve, reject);
        },
      };
      if (signal && signal.aborted) { reject(abortError()); return; }
      if (signal) signal.addEventListener('abort', onAbort, { once: true });
      h.queue.push(item); next(h);
    });
  };
}
